import { ProductType } from '../../../common';
import { FromPrice, SFCCGroupPrice, SFCCPricingSearchResult } from '../../models';
import { getPricesByIds } from './get-prices-by-ids';

export const getGroupPrice = async (
  groupId: number
): Promise<FromPrice | SFCCGroupPrice | null> => {
  try {
    const prices = await getPricesByIds<FromPrice[] | SFCCPricingSearchResult>(
      [groupId],
      ProductType.Group
    );

    if (!prices) {
      return null;
    }

    if (Array.isArray(prices)) {
      return prices[0] || null;
    }

    if ('search_phrase_suggestions' in prices && prices.search_phrase_suggestions?.c_prices) {
      return prices.search_phrase_suggestions.c_prices[0] || null;
    }

    return null;
  } catch (error) {
    console.error(`Error fetching group price for groupId ${groupId}:`, error);
    return null;
  }
};
